import { useEffect, useState } from "react";
import { useOrganizationList, useUser } from "@clerk/clerk-react";

import LoadingState from "../ui/loading-state";
import { toast } from "sonner";
import { useNavigate } from "@tanstack/react-router";

const WaitForOrg = () => {
    const navigate = useNavigate();
    const { isLoaded, isSignedIn, user } = useUser();
    const { setActive } = useOrganizationList();
    const [isRedirecting, setIsRedirecting] = useState(false);

    useEffect(() => {
        async function init() {
            console.log("[WaitForOrg] User state:", { isLoaded, isSignedIn, user });

            if (!isLoaded) return;

            if (!isSignedIn) {
                navigate({ to: '/sign-in' });
                return;
            }

            if (isSignedIn && user) {
                try {
                    setIsRedirecting(true);
                    const orgs = await user.getOrganizationMemberships();
                    console.log("[WaitForOrg] User organizations:", orgs);

                    if (orgs.data.length > 0) {
                        const { organization } = orgs.data[0];
                        const orgSlug = organization.slug;
                        if (orgSlug) {
                            try {
                                if (setActive) {
                                    await setActive({ organization: organization.id });
                                }
                            } catch (e) {
                                console.error("[WaitForOrg] Failed to set active organization:", e);
                            }

                            console.log("[WaitForOrg] Redirecting to org:", orgSlug);
                            navigate({ to: '/org/$orgSlug', params: { orgSlug } });
                        } else {
                            console.log("[WaitForOrg] Org found but no slug, redirecting to create org");
                            navigate({ to: '/create-org' });
                        }
                    } else {
                        console.log("[WaitForOrg] No orgs found, redirecting to create org");
                        toast.info("Please create an organization to continue", {
                            duration: 5000,
                        });
                        navigate({ to: '/create-org' });
                    }
                } catch (error) {
                    console.error("[WaitForOrg] Error checking orgs:", error);
                    toast.error("Failed to check organizations. Please try again.");
                    navigate({ to: '/' });
                } finally {
                    setIsRedirecting(false);
                }
            }
        }

        if (isLoaded && !isRedirecting) {
            init();
        }
    }, [navigate, isLoaded, isSignedIn, user, isRedirecting, setActive]);

    return (
        <LoadingState
            fullScreen
            message="Looking for your organizations..."
        />
    );
};

export default WaitForOrg; 